export const GET_COUNTRY = "GET_COUNTRY";
export const GET_MEMBER_INFO = "GET_MEMBER_INFO";